import React from 'react';

class Footer extends React.PureComponent {
  render() {
    return (
      <footer>
        <p className="footer-text">
          Rubén D. Pire | 2021
        </p>
      </footer>
    );
  }
}

export default Footer;
